import React from 'react';
import { useHits } from 'react-instantsearch';

import RelatedContent from '../RelatedContent';
import SearchEvents from '../SearchEvents';

import './style.scss';

export interface RelatedEventsProps {
  targetId: number;
  title?: string;
  moreUrl?: string;
}

const RelatedEventsInner: React.FC<Omit<RelatedEventsProps, 'targetId'>> = (props) => {
  const { title, moreUrl } = props;

  const { hits } = useHits();

  if (!hits || hits.length === 0) {
    return null;
  }

  return (
    <RelatedContent className="RelatedEvents">
      {title && (
        <div className="row">
          <RelatedContent.Title
            className="col-lg-7"
            title={title}
          />
        </div>
      )}

      <SearchEvents.Results />

      <RelatedContent.MoreButton
        url={moreUrl}
      />
    </RelatedContent>
  );
};

const RelatedEvents: React.FC<RelatedEventsProps> = (props) => {
  const { targetId, ...restProps } = props;

  return (
    <SearchEvents targetAudienceId={targetId}>
      <RelatedEventsInner {...restProps} />
    </SearchEvents>
  );
};

export default RelatedEvents;
